import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    configurations: []
};

export const configSlice = createSlice({
    name: 'configSlice',
    initialState,
    reducers: {
       
        getAllConfigurations: (state, action) => {
            state.configurations = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { getAllConfigurations} = configSlice.actions;

export default configSlice.reducer;
